(function(angular) {
    'use strict';

    angular.module('thehub.cvWriting')
        .constant('PROVIDERS', {
            CV_NOW: { name: 'CV Now', value: 'CVNow'}
        });

})(angular);
